module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/swatchbook.svg?93024411fda0c8070c15e0997c677524";